export default "__VITE_PUBLIC_ASSET__608fdf18__"